import { Box, Icon, Tabs, Text } from '@chakra-ui/react';
import { HeadingPortal } from '@mono/layout';
import { FC, Fragment } from 'react';
import { useNavigate, useParams } from 'react-router';
import { FiUsers } from 'react-icons/fi';
import OrganizationsSettingsTab from '../organizations/OrganizationsSettingsTab';
import TeamsSettingsTab from '../teams/TeamsSettingsTab';
import { useCurrentOrganization } from '../organizations/hooks';
import UsersSettingsTab from '../users/UsersSettingsTab';

const tabItems = [
  {
    value: 'organization',
    label: 'Organization',
    icon: FiUsers,
    Component: OrganizationsSettingsTab,
  },
  {
    value: 'teams',
    label: 'Teams',
    icon: FiUsers,
    Component: TeamsSettingsTab,
  },
  {
    value: 'users',
    label: 'Users',
    icon: FiUsers,
    Component: UsersSettingsTab,
  },
] as const;

const SettingsPage: FC = () => {
  const params = useParams<{ tab: string }>();
  const navigate = useNavigate();
  const org = useCurrentOrganization();

  const onChangeTab = (details: { value: string }) => {
    navigate(`/${org?.slug}/settings/${details.value}`);
  };

  return (
    <Fragment>
      <HeadingPortal>Settings</HeadingPortal>
      <Box
        position={'absolute'}
        top={0}
        left={0}
        width={'100%'}
        height={'100%'}
        overflow={'auto'}
      >
        <Tabs.Root
          value={params.tab ?? 'organization'}
          onValueChange={onChangeTab}
          orientation="vertical"
          height={'100%'}
          lazyMount
        >
          <Tabs.List pt={8}>
            {tabItems.map((tab) => (
              <Tabs.Trigger key={tab.value} value={tab.value}>
                <Icon as={tab.icon} />
                <Text fontWeight="semibold">{tab.label}</Text>
              </Tabs.Trigger>
            ))}
          </Tabs.List>

          <Box flex="1" minW="0" h="full">
            {tabItems.map((tab) => {
              const TabComponent = tab.Component;
              return (
                <Tabs.Content
                  key={tab.value}
                  value={tab.value}
                  h="full"
                  p={8}
                  boxSizing={'border-box'}    
                >
                  <TabComponent />
                </Tabs.Content>
              );
            })}
          </Box>
        </Tabs.Root>
      </Box>
    </Fragment>
  );
};

export default SettingsPage;
